import AbstractUnit from './AbstractUnit';
import HeaderUnit from './HeaderUnit';
import { SIZE_OPTIONS } from '../../../../constants/size';

// const THREE = require('three');

class ArticleHeaderUnit extends AbstractUnit {
    _setup(data, stgs, webgl) {
        super._setup(data, stgs, webgl);

        // Default
        this._orientation = SIZE_OPTIONS.LANDSCAPE;
        this.hasResize = true;
    }

    _constructView(data, webgl, stgs) {
        const textUnit = new HeaderUnit(data, webgl, stgs);

        this.add(textUnit);

        this.textUnit = textUnit;
        this.mainView = textUnit;
    }

    resize(winWidth, winHeight, orientation, force, pixelRatio) {
        if (this.textUnit.hasResize) this.textUnit.resize(winWidth, winHeight, orientation, force, pixelRatio);

        if (this._orientation === orientation && !force) return;

        this._orientation = orientation;
    }
}

export default ArticleHeaderUnit;
